<template>
  <v-container >
    <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
    <h1 class="mt-8 mb-0">お問い合わせ</h1>
    <div id="valtec_ma__creative_form_section__a163f0f4db9eee7fc13d43e55a8a0d7e_9c4e97e5412487b91e0782203264b1fb"></div>
    <!--
    <div class="mb-4 text--primary">下記すべてのフォームにご入力をお願いいたします</div>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <form @submit.prevent="submit()">
        <v-row justify="center" align-content="center">
          <v-col cols="3">
            <badge-component tile content="必　須" color="red">
              <label-component>氏名</label-component>
            </badge-component>
          </v-col>
          <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                name="name"
                rules="required|max:255"
              >
                <v-text-field
                  v-model="name"
                  :error-messages="errors"
                  required
                  outlined
                  clearable
                  v-disabled-icon-focus
                  background-color="white"
                ></v-text-field>
              </validation-provider>
          </v-col>
        </v-row>
        <v-row justify="center" align-content="center">
          <v-col cols="3">
            <badge-component tile content="必　須" color="red">
              <label-component>メールアドレス</label-component>
            </badge-component>
          </v-col>
          <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                name="email"
                rules="required|email"
              >
               <v-text-field
                  v-model="email"
                  :error-messages="errors"
                  outlined
                  clearable
                  v-disabled-icon-focus
                  background-color="white"
                ></v-text-field>
              </validation-provider>
          </v-col>
        </v-row>
        <v-row justify="center" align-content="center">
          <v-col cols="3">
            <badge-component tile content="必　須" color="red">
              <label-component>件名</label-component>
            </badge-component>
          </v-col>
          <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                name="title"
                rules="required|max:255"
              >
                <v-text-field
                  v-model="title"
                  :error-messages="errors"
                  required
                  outlined
                  clearable
                  v-disabled-icon-focus
                  background-color="white"
                ></v-text-field>
              </validation-provider>
          </v-col>
        </v-row>
        <v-row justify="center" align-content="center">
          <v-col cols="3">
            <badge-component tile content="必　須" color="red">
              <label-component>内容</label-component>
            </badge-component>
          </v-col>
          <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                name="content"
                rules="required"
              >
                <v-textarea
                  v-model="content"
                  :error-messages="errors"
                  required
                  outlined
                  clearable
                  v-disabled-icon-focus
                  background-color="white"
                ></v-textarea>
              </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="11" class="text--primary">
            このサイトはreCAPTCHAで保護されており、
            Googleの<a href="https://policies.google.com/privacy" target="_blank">プライバシーポリシー</a>
            と
            <a href="https://policies.google.com/terms" target="_blank">利用規約</a>
            が適用されます。
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12" xl="12"
              >
              <v-btn
                class="mr-4 white--text"
                color="red"
                :disabled="invalid"
                v-if="!isSubmitting" 
                v-on:click="submit()"
              >
                送信
              </v-btn>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
  -->
  </v-container>
</template>
<script>
  import Vue from 'vue';
  // import { VueReCaptcha } from 'vue-recaptcha-v3';
  // import { required, email, max } from 'vee-validate/dist/rules';
  // import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
  // extend('required', {
  //   ...required,
  //   message: '入力必須項目です',
  // });
  // extend('max', {
  //   ...max,
  //   message: '{length} 文字以内でご入力ください',
  // });
  // extend('email', {
  //   ...email,
  //   message: '正しいメールアドレスを入力してください',
  // });
  // Vue.use( VueReCaptcha, {
  //   // siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
  //   siteKey: "6Lf63PAcAAAAAPjLClo4VQJ1Zbi-9MkyO14UrcZ1",
  // });
    export default {
        // components: {
        //   ValidationProvider,
        //   ValidationObserver,
        //   VueReCaptcha,
        // },
        props: {
            reCapchaSiteKey: String,
            user: Object,
            dbCompanyName: String
        },
        data: function () {
          return {
              name: this.user? this.user.name : null,
              title: null,
              content: null,
              email: this.user? this.user.email : null,
              companyName: this.dbCompanyName? this.dbCompanyName : null,
              isSubmitting: false, //送信中かどうかを判別
              // メッセージ
              message: null,
              success: false,
          };
        },
        // methods: {
        //   async submit() {
        //     if(!confirm('送信します。よろしいですか？')) {
        //       return;
        //     }
        //     await this.$recaptchaLoaded();
        //     const token = await this.$recaptcha('contact');
        //     this.isSubmitting = true;
        //     this.$refs.observer.validate().then((result) => {
        //       if(result) {
        //         var params = {
        //           'name': this.name,
        //           'title': this.title,
        //           'content': this.content,
        //           'email': this.email,
        //           token
        //         };
        //         axios.post('/documents/contact', params)
        //         .then((response) => {
        //           this.success = response.data.success;
        //           if (this.success) {
        //             window.location = "/documents/contact_complete";
        //           }
        //         })
        //         .catch((error) => {
        //           this.success = false;
        //           if(error.response != null && error.response.status == 422) {
        //             this.message = "機械的なアクセスだと判定されました。画面の「更新」あるいは「再読み込み（リロード）」をしてもう一度実行してください。";
        //           } else {
        //             this.message = "送信エラーが発生しました。画面の「更新」あるいは「再読み込み（リロード）」をしてもう一度実行してください。";
        //           }
        //         })
        //         .then(() => {
        //             this.isSubmitting = false;
        //         });
        //       }
        //     });
        //   },
        // },
        mounted() {
          setTimeout(()=>{
            let nameEle = document.querySelector(`[id^='name___VTMA_']`);
            if (nameEle != null) {
              nameEle.value = this.name;
            }
            
            let companyNameEle = document.querySelector(`[id^='company___VTMA_']`);
            if (companyNameEle != null) {
              companyNameEle.value = this.companyName;
            }

            let emailEle = document.querySelector(`[id^='email_address___VTMA_']`);
            if (emailEle != null) {
              emailEle.value = this.email;
            }
          },2000);
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
  };
</script>
<style scoped>
::v-deep th {
    font-size: 1.6rem;
}
::v-deep input {
    font-size: 1.6rem!important;
}
::v-deep textarea {
    font-size: 1.6rem!important;    
}
::v-deep p {
    font-size: 1.6rem!important;    
}
</style>